var membershipApp = angular.module('membershipApp', ['ngSanitize', 'ngCookies', 'ngRoute', 'pascalprecht.translate', 'angularUtils.directives.dirPagination', 'app'])

membershipApp.config(['$routeProvider', '$httpProvider', '$translateProvider', function ($routeProvider, $httpProvider, $translateProvider) {
	
	$httpProvider.defaults.timeout = 5000;

	$translateProvider.fallbackLanguage('bg');
	$translateProvider.registerAvailableLanguageKeys(['bg', 'en', 'es', 'esc', 'pt', 'esm', 'it', 'ro', 'lt', 'id', 'de', 'mk'], {
		'bg_*': 'bg',
		'en_*': 'en',
		'es_*': 'es',
		'esc_*': 'esc',
		'pt_*': 'pt',
		'esm_*': 'esm',
		'it_*': 'it',
		'ro_*': 'ro',
		'lt_*': 'lt',
		'id_*': 'id',
		'de_*': 'de',
		'mk_*': 'mk'
	});

	var ob_bg;
	var ob_en;
	var ob_es;
	var ob_esc;
	var ob_pt;
	var ob_esm;
	var ob_it;
	var ob_ro;
	var ob_lt;
	var ob_id;
	var ob_de;
	var ob_mk;

	$.ajax({
		async: false,
		url: "../frontend/wipcustomersportal/src/translate/bg.json",
		success: function (json) {
			ob_bg = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/wipcustomersportal/src/translate/en.json",
		success: function (json) {
			ob_en = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/wipcustomersportal/src/translate/es.json",
		success: function (json) {
			ob_es = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/wipcustomersportal/src/translate/esc.json",
		success: function (json) {
			ob_esc = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/wipcustomersportal/src/translate/pt.json",
		success: function (json) {
			ob_pt = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/wipcustomersportal/src/translate/esm.json",
		success: function (json) {
			ob_esm = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/wipcustomersportal/src/translate/it.json",
		success: function (json) {
			ob_it = json;
		}
	});
	$.ajax({
		async: false,
		url: "../frontend/wipcustomersportal/src/translate/ro.json",
		success: function (json) {
			ob_ro = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/wipcustomersportal/src/translate/lt.json",
		success: function (json) {
			ob_lt = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/wipcustomersportal/src/translate/id.json",
		success: function (json) {
			ob_id = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/wipcustomersportal/src/translate/de.json",
		success: function (json) {
			ob_de = json;
		}
	});

	$.ajax({
		async: false,
		url: "../frontend/wipcustomersportal/src/translate/mk.json",
		success: function (json) {
			ob_mk = json;
		}
	});

	$translateProvider.translations('en', ob_en);
	$translateProvider.translations('bg', ob_bg);
	$translateProvider.translations('es', ob_es);
	$translateProvider.translations('esc', ob_esc);
	$translateProvider.translations('pt', ob_pt);
	$translateProvider.translations('esm', ob_esm);
	$translateProvider.translations('it', ob_it);
	$translateProvider.translations('ro', ob_ro);
	$translateProvider.translations('lt', ob_lt);
	$translateProvider.translations('id', ob_id);
	$translateProvider.translations('de', ob_de);
	$translateProvider.translations('mk', ob_mk);

	$translateProvider.preferredLanguage('bg');
	$translateProvider.preferredLanguage('en');
	$translateProvider.useLocalStorage();
}]);